var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiscoStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0598 3.286L14.7617 0.302101C14.6527 0.257579 14.5359 0.234863 14.4178 0.234863H8.58178C8.46366 0.234863 8.3469 0.258033 8.23786 0.302101L0.939849 3.286C0.502804 3.465 0.27565 3.94838 0.416485 4.3986L1.76851 8.71408C1.9157 9.18475 2.41181 9.45324 2.88702 9.31559L4.94731 8.72271V17.4977C4.94731 17.9992 5.35437 18.4063 5.85592 18.4063H17.1437C17.6452 18.4063 18.0523 17.9992 18.0523 17.4977V8.72226L20.113 9.31559C20.586 9.45279 21.0839 9.1852 21.2311 8.71408L22.5831 4.3986C22.7244 3.94838 22.4968 3.46454 22.0598 3.286ZM13.8272 2.05164C13.4869 3.10882 12.5733 3.86888 11.4998 3.86888C10.4263 3.86888 9.51311 3.10882 9.17238 2.05164H13.8272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiscoStore);
export default __webpack_public_path__ + "static/media/cisco-store.d029f1445da5feec371b253744925d9d.svg";
export { ForwardRef as ReactComponent };